import React from 'react'

import { Icon } from '@fourthwall/components'
import { PhotoIcon } from '@fourthwall/icons'

import { QuantityBadge } from '../QuantityBadge'
import * as S from './styled'
import type { ImagePreviewProps } from './types'

export const ImagePreview = ({ image, imagesCount }: ImagePreviewProps) => {
  const renderContent = () => {
    if (!image) {
      return (
        <S.PreviewIcon data-testid="ImagePreview">
          <Icon component={PhotoIcon} height={24} />
        </S.PreviewIcon>
      )
    }

    return (
      <>
        <S.Image src={image} />
        {imagesCount && imagesCount > 1 && <QuantityBadge quantity={imagesCount} />}
      </>
    )
  }

  return <S.Container>{renderContent()}</S.Container>
}
